import { withHTMLComponent } from '@updater-local/custom-element-v1';
import './reviews';
import './features';
import './coverage-areas';
import styles from './index.css';
import html from './index.html';

export default class CompanyProfileContent extends withHTMLComponent(
  styles,
  html
)() {
  static props = ['value'];

  constructor() {
    super();
    this._about = this.shadowRoot.querySelector('#about');
    this._reviews = this.shadowRoot.querySelector('#reviews');
    this._features = this.shadowRoot.querySelector(
      'upd-moveiq-company-features'
    );
    this._coverageAreas = this.shadowRoot.querySelector(
      'upd-moveiq-company-coverage-areas'
    );
    this._coverageAreasWrapper = this.shadowRoot.querySelector('#coverage');
  }

  updated({
    value: {
      rating: { reviews, qualityRating },
      description,
      affiliations,
      noteworthy,
      services,
      coverageAreas,
    },
  }) {
    this._features.value = { affiliations, noteworthy, services };
    this._about.textContent = description;
    // this._coverageAreas.value = coverageAreas;
    maybeSetValue(this._reviews, 'upd-moveiq-company-reviews', reviews);
    maybeSetValue(
      this._coverageAreasWrapper,
      'upd-moveiq-company-coverage-areas',
      coverageAreas
    );
  }
}

customElements.define(
  'upd-moveiq-company-profile-content',
  CompanyProfileContent
);

function maybeSetValue(hideElement, componentSelector, value) {
  if (value.length > 0) {
    hideElement.style.display = 'block';
    hideElement.querySelector(componentSelector).value = value;
  } else {
    hideElement.style.display = 'none';
  }
}
